import type React from 'react'

import { Tooltip } from 'components/Tooltip'
import { theme } from 'styles/theme/hav-theme'

import { Container, TagStyled } from './styles'
export interface TagProps {
  background?: string
  children: React.ReactNode
  tooltipLabel?: string
}

export const Tag = ({
  children,
  tooltipLabel = '',
  background = theme.colors.alert.warning.main,
}: TagProps) => {
  return (
    <Tooltip arrow placement="top" title={tooltipLabel}>
      <TagStyled background={background}>
        <Container>{children}</Container>
      </TagStyled>
    </Tooltip>
  )
}
